import { render, staticRenderFns } from "./vRecipeDeleteConfirmationModal.vue?vue&type=template&id=fe654dde&scoped=true"
import script from "./vRecipeDeleteConfirmationModal.vue?vue&type=script&lang=ts"
export * from "./vRecipeDeleteConfirmationModal.vue?vue&type=script&lang=ts"
import style0 from "./vRecipeDeleteConfirmationModal.vue?vue&type=style&index=0&id=fe654dde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe654dde",
  null
  
)

export default component.exports